export default "__VITE_ASSET__5f6064ce__"